import React from "react";
import styled from "styled-components";
import {Box, Container} from "@mui/material";
import {SocialLinks} from "./SocialLinks";
import {useTranslation} from "react-i18next";
import logo from "assets/images/logos/fifa_plus_logo.svg";
import appStore from "assets/images/logos/appleAppStore.png";
import playStore from "assets/images/logos/googlePlay.png";
import {PartnerLinks} from "./PartnerLinks";
import {SponsorLinks} from "./SponsorLinks";
import {Exist} from "components";
import {SHOW_FOOTER_LINKS, SHOW_SPONSORS} from "modules";
import {media} from "assets/css/media";

const Wrapper = styled.footer`
	background-color: ${({theme}) => theme.global.footer_background};
`;

const FooterTop = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	min-height: 56px;
`;

const FooterBottom = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding-top: 24px;
	padding-bottom: 24px;

	@media (max-width: ${media.mobile}) {
		align-items: flex-start;
		flex-direction: column;
	}
`;

const Divider = styled.hr`
	height: 1px;
	background-color: ${({theme}) => theme.secondary};
	border: none;
	margin: 0;
`;

const FifaLogo = styled.img`
	margin-right: 200px;

	@media (max-width: 900px) {
		margin-right: 16px;
	}
`;

const AppText = styled.p`
	color: #fff;
	font-size: 14px;
	font-weight: 500;
	margin-right: 100px;

	@media (max-width: 1440px) {
		display: none;
	}
`;

const AppImage = styled.img`
	margin-left: 8px;
	margin-right: 8px;

	@media (max-width: ${media.mobile}) {
		height: 25px;
	}
`;

const FooterLinks = styled.nav`
	display: flex;

	@media (max-width: ${media.mobile}) {
		flex-direction: column;
	}
`;

const FooterLink = styled.a`
	color: #fff;
	font-size: 14px;
	font-weight: 500;
	margin-left: 30px;
	margin-right: 30px;
	transition: color 0.2s ease-in-out;

	&:hover {
		color: ${({theme}) => theme.secondary};
	}

	@media (max-width: ${media.mobile}) {
		margin: 0;
		margin-bottom: 16px;
	}
`;

const Copyright = styled.span`
	color: #fff;
	font-size: 10px;
`;

export const Footer: React.FC = () => {
	const {t} = useTranslation();

	return (
		<Wrapper>
			<Container maxWidth={false}>
				<FooterTop>
					<Box
						sx={{
							display: "flex",
						}}>
						<a href="https://origin1904-fifaplus-uat.cxm.fifa.com/">
							<FifaLogo src={logo} alt="Fifa Plus" />
						</a>
						<SocialLinks />
					</Box>
					<Box
						sx={{
							display: "flex",
							alignItems: "center",
						}}>
						<AppText>{t("footer.fifa.download")}</AppText>
						<a href="https://play.google.com/store/apps/details?id=com.fifa.fifaapp.android&hl=en">
							<AppImage src={playStore} alt="Google Play" />
						</a>
						<a href="https://apps.apple.com/us/app/fifa-official-app/id756904853">
							<AppImage src={appStore} alt="App Store" />
						</a>
					</Box>
				</FooterTop>
			</Container>
			<Divider />
			<Exist when={SHOW_SPONSORS}>
				<Container maxWidth={false}>
					<Box
						sx={{
							paddingTop: "24px",
							paddingBottom: "24px",
						}}>
						<PartnerLinks />
						<SponsorLinks />
					</Box>
				</Container>
				<Divider />
			</Exist>
			<Container maxWidth={false}>
				<FooterBottom>
					<FooterLinks>
						<Exist when={SHOW_FOOTER_LINKS}>
							<FooterLink href="">{t("footer.fifa.terms")}</FooterLink>
							<FooterLink href="">{t("footer.fifa.data")}</FooterLink>
							<FooterLink href="">{t("footer.fifa.cookie")}</FooterLink>
						</Exist>
					</FooterLinks>
					<Copyright>{t("footer.fifa.copryright")}</Copyright>
				</FooterBottom>
			</Container>
		</Wrapper>
	);
};
